import { render, staticRenderFns } from "./pg_business_casestudy.vue?vue&type=template&id=0f0e690e"
import script from "./pg_business_casestudy.vue?vue&type=script&lang=js"
export * from "./pg_business_casestudy.vue?vue&type=script&lang=js"
import style0 from "./pg_business_casestudy.vue?vue&type=style&index=0&id=0f0e690e&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports